






import { Vue, Component, Prop } from 'vue-property-decorator';
import ConfigPopup from '@/components/Product/Configurator/ConfigPopup.vue';
@Component({
    components: {
        ConfigPopup
    }
})
export default class Complement extends Vue {
    @Prop()
    protected pageUrl!: string;

    constructor() {
        super();
    }
    private showModal(e: Event) {
        e.preventDefault();
        const url = this.pageUrl;
        this.$modal.show(ConfigPopup, { url }, { adaptive: true, styles: { backgroundColor: '#f7f7f7' } });
    }
}
